import { defineComponent as V, openBlock as o, createElementBlock as l, mergeProps as i, unref as e, renderSlot as m, createElementVNode as n, createCommentVNode as A } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const g = { key: 0 }, H = { key: 1 }, Z = { key: 2 }, f = { key: 3 }, k = { key: 4 }, L = { key: 5 }, h = {
  name: "ScalarIconBookmarkSimple"
}, M = /* @__PURE__ */ V({
  ...h,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = u(s);
    return (p, t) => (o(), l("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      m(p.$slots, "default"),
      e(a) === "bold" ? (o(), l("g", g, t[0] || (t[0] = [
        n("path", { d: "M184,28H72A20,20,0,0,0,52,48V224a12,12,0,0,0,18.36,10.18l57.63-36,57.65,36A12,12,0,0,0,204,224V48A20,20,0,0,0,184,28Zm-4,174.35-45.65-28.53a12,12,0,0,0-12.72,0L76,202.35V52H180Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (o(), l("g", H, t[1] || (t[1] = [
        n("path", {
          d: "M192,48V224l-64-40L64,224V48a8,8,0,0,1,8-8H184A8,8,0,0,1,192,48Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M184,32H72A16,16,0,0,0,56,48V224a8,8,0,0,0,12.24,6.78L128,193.43l59.77,37.35A8,8,0,0,0,200,224V48A16,16,0,0,0,184,32Zm0,177.57-51.77-32.35a8,8,0,0,0-8.48,0L72,209.57V48H184Z" }, null, -1)
      ]))) : e(a) === "fill" ? (o(), l("g", Z, t[2] || (t[2] = [
        n("path", { d: "M184,32H72A16,16,0,0,0,56,48V224a8,8,0,0,0,12.24,6.78L128,193.43l59.77,37.35A8,8,0,0,0,200,224V48A16,16,0,0,0,184,32Z" }, null, -1)
      ]))) : e(a) === "light" ? (o(), l("g", f, t[3] || (t[3] = [
        n("path", { d: "M184,34H72A14,14,0,0,0,58,48V224a6,6,0,0,0,9.18,5.09l60.81-38,60.83,38A6,6,0,0,0,198,224V48A14,14,0,0,0,184,34Zm2,179.17-54.83-34.26a6,6,0,0,0-6.36,0L70,213.17V48a2,2,0,0,1,2-2H184a2,2,0,0,1,2,2Z" }, null, -1)
      ]))) : e(a) === "regular" ? (o(), l("g", k, t[4] || (t[4] = [
        n("path", { d: "M184,32H72A16,16,0,0,0,56,48V224a8,8,0,0,0,12.24,6.78L128,193.43l59.77,37.35A8,8,0,0,0,200,224V48A16,16,0,0,0,184,32Zm0,177.57-51.77-32.35a8,8,0,0,0-8.48,0L72,209.57V48H184Z" }, null, -1)
      ]))) : e(a) === "thin" ? (o(), l("g", L, t[5] || (t[5] = [
        n("path", { d: "M184,36H72A12,12,0,0,0,60,48V224a4,4,0,0,0,6.12,3.39L128,188.72l61.89,38.67A4,4,0,0,0,192,228a4.06,4.06,0,0,0,1.94-.5A4,4,0,0,0,196,224V48A12,12,0,0,0,184,36Zm4,180.78-57.89-36.17a4,4,0,0,0-4.24,0L68,216.78V48a4,4,0,0,1,4-4H184a4,4,0,0,1,4,4Z" }, null, -1)
      ]))) : A("", !0)
    ], 16));
  }
});
export {
  M as default
};
